import React from 'react';
import { cx } from '../cx';

// D-07 §21 — PageHeader (.page-header). 좌 타이틀(+서브) / 우 액션 슬롯.
// 시그니처는 D-06 §11.1 규격을 승계하고, 웹은 onBack 을 더한다.
export interface PageHeaderProps extends Omit<React.HTMLAttributes<HTMLDivElement>, 'title'> {
  title: React.ReactNode;
  subtitle?: React.ReactNode;
  /** 우측 액션 슬롯 (버튼 묶음 등) */
  extra?: React.ReactNode;
  /** 지정하면 제목 왼쪽에 뒤로가기 버튼을 노출한다 */
  onBack?: () => void;
  /** 뒤로가기 버튼의 접근성 레이블 */
  backLabel?: string;
}

export function PageHeader({
  title,
  subtitle,
  extra,
  onBack,
  backLabel = '뒤로',
  className = '',
  ...props
}: PageHeaderProps) {
  return (
    <div className={cx('page-header', className)} {...props}>
      <div className="page-header-main">
        {onBack && (
          <button type="button" className="page-header-back" onClick={onBack} aria-label={backLabel}>
            <svg
              width="18" height="18" viewBox="0 0 24 24" fill="none"
              stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"
            >
              <polyline points="15 18 9 12 15 6" />
            </svg>
          </button>
        )}
        <div className="page-header-text">
          <h1 className="page-header-title">{title}</h1>
          {subtitle != null && <p className="page-header-sub">{subtitle}</p>}
        </div>
      </div>
      {extra != null && <div className="page-header-extra">{extra}</div>}
    </div>
  );
}
